import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './toast-utils.css';

const showSuccessToast = (message) => {
  toast.success(message, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme:'colored'
  });
};

const showErrorToast = (message) => {
    toast.error(message, {
      position: 'top-right',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme:'colored'
    });
  };

export { showSuccessToast, showErrorToast };
